import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/**
 * The proposed runs of a dossier, in progress and completed alike. Pagination is set by `getPaginated`,
 * not by the query string.
 */
class FetchBeneficiaryWorkflowRuns {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return new URLSearchParams({ launchMode: 'proposal' }).toString();
	}
}

export default FetchBeneficiaryWorkflowRuns;
